import { useEffect, useState } from "react";
import { ImageWithFallbackProps } from "./image-with-fallback.types";
import { assetPath } from "@/utility";

export default function ImageWithFallback({
  alt,
  src,
  ...props
}: ImageWithFallbackProps): React.ReactElement {
  const [err, setErr] = useState(false);

  useEffect(() => {
    setErr(false);
  }, [src]);

  return (
    <img
      alt={alt}
      onError={() => setErr(true)}
      src={
        err
          ? assetPath(src)
          : assetPath(src, process.env.ASSET_SERVER_FALLBACK ?? "/assets")
      }
      {...props}
    />
  );
}
